import PropTypes from 'prop-types';
import React from 'react';
import FieldHelperText from '~components/field-helper-text/index';

const FormikFieldHelperText = ({ meta, ...otherProps }) => {
  return (
    <FieldHelperText type="error" {...otherProps}>
      {otherProps?.children ?? (meta.touched && meta.error)}
    </FieldHelperText>
  );
};

FormikFieldHelperText.propTypes = {
  type: PropTypes.oneOf(['error', 'warning']),
  children: PropTypes.node,
  className: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.any,
  }),
};

FormikFieldHelperText.defaultProps = {
  type: undefined,
  children: null,
  className: undefined,
  meta: {},
};

export default FormikFieldHelperText;
